import { render, staticRenderFns } from "./DetailsDialog.vue?vue&type=template&id=3b34f8de&scoped=true&"
import script from "./DetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./DetailsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsDialog.vue?vue&type=style&index=0&id=3b34f8de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b34f8de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VDialog,VIcon})
